import { createStorageObjectItemContext } from "conference/storageObjectItemManager";
import { conferenceSessionStorage } from "conference/tools";
import { defaultRoomSettings } from "conference/components/meeting-page/room/types";

export const RoomSettings = createStorageObjectItemContext(
    conferenceSessionStorage,
    "roomSettings",
    defaultRoomSettings
);

export const useRoomSettings = RoomSettings.getterHook;
